import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Buildings from "@/pages/admin/Buildings";
import BuildingDetail from "@/pages/admin/BuildingDetail";
import Personnel from "@/pages/admin/Personnel";
import Materials from "@/pages/admin/Materials";
import YapSat from "@/pages/admin/YapSat";
import YapSatDetail from "@/pages/admin/YapSatDetail";
import Messages from "@/pages/admin/Messages";
import References from "@/pages/admin/References";
import Content from "@/pages/admin/Content";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#121212] text-[#d4af37] font-display">
        Yükleniyor...
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/hakkimizda" element={<About />} />
              <Route path="/hizmetlerimiz" element={<Services />} />
              <Route path="/hizmetlerimiz/:slug" element={<Services />} />
              <Route path="/projelerimiz" element={<Projects />} />
              <Route path="/iletisim" element={<Contact />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="yalitim" element={<Buildings />} />
              <Route path="yalitim/:id" element={<BuildingDetail />} />
              <Route path="personel" element={<Personnel />} />
              <Route path="malzeme" element={<Materials />} />
              <Route path="yapsat" element={<YapSat />} />
              <Route path="yapsat/:id" element={<YapSatDetail />} />
              <Route path="referanslar" element={<References />} />
              <Route path="icerik" element={<Content />} />
              <Route path="mesajlar" element={<Messages />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
